import { render } from "./UnsubscribeModal.vue?vue&type=template&id=c178779a&scoped=true"
import script from "./UnsubscribeModal.vue?vue&type=script&lang=js"
export * from "./UnsubscribeModal.vue?vue&type=script&lang=js"

import "./UnsubscribeModal.vue?vue&type=style&index=0&id=c178779a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c178779a"]])

export default __exports__